import React from "react";

interface IPageNotFoundProps {}

export const PageNotFound: React.FunctionComponent<IPageNotFoundProps> = (
  props
) => {
  return <div>PAGE NOTE FOUND</div>;
};
